"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.KPISizes = exports.KPIColors = void 0;

var _theme = require("../../theme");

var KPIColors;
exports.KPIColors = KPIColors;

(function (KPIColors) {
  KPIColors[KPIColors["green"] = _theme.PaletteColors.green] = "green";
  KPIColors[KPIColors["mint"] = _theme.PaletteColors.mintMain] = "mint";
  KPIColors[KPIColors["orange"] = _theme.PaletteColors.orange] = "orange";
  KPIColors[KPIColors["purple"] = _theme.PaletteColors.purple] = "purple";
  KPIColors[KPIColors["red"] = _theme.PaletteColors.red] = "red";
  KPIColors[KPIColors["teal"] = _theme.PaletteColors.teal] = "teal";
  KPIColors[KPIColors["yellow"] = _theme.PaletteColors.yellow] = "yellow";
})(KPIColors || (exports.KPIColors = KPIColors = {}));

var KPISizes;
exports.KPISizes = KPISizes;

(function (KPISizes) {
  KPISizes["small"] = "small";
  KPISizes["large"] = "large";
})(KPISizes || (exports.KPISizes = KPISizes = {}));